// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2QIdq","header":"Messages_header__3ZO5i"};